import { render, staticRenderFns } from "./UserDetailsDrawer.vue?vue&type=template&id=7dd78fe2&scoped=true&"
import script from "./UserDetailsDrawer.vue?vue&type=script&lang=js&"
export * from "./UserDetailsDrawer.vue?vue&type=script&lang=js&"
import style0 from "./UserDetailsDrawer.vue?vue&type=style&index=0&id=7dd78fe2&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd78fe2",
  null
  
)

export default component.exports